<template>
  <LeftSide>
    <template v-slot:title>
      Reference letter
    </template>
    <div class="mt-2">
      <div class="bg-grey-blue p-3 rounded">
        <FormulateForm v-if="reference"
                       name="formulateForm"
                       @submit="handleSubmitForm"
                       v-model="formValues"
                       :errors="formErrors">
          <ifac-reference-form :reference="reference" :schema="formSchema"/>
        </FormulateForm>
      </div>

      <div class="row submit-buttons">
        <div class="col text-right right-col p-0">
          <button
            v-if="reference"
            type="submit"
            class="btn btn-secondary"
            :disabled="!reference.can.update"
            @click="saveForm"
          >
            Save
          </button>
          <button
            v-if="reference"
            type="submit"
            class="btn btn-primary"
            :disabled="!reference.can.submit"
            @click="submitForm"
          >
            Submit letter
          </button>
        </div>
      </div>
    </div>
  </LeftSide>
</template>

<script>
import awardsMixin from '@/mixins/awards/awards.mixin';
import referencesMixin from '@/mixins/awards/references.mixin';
import { ifacUiMixin, IfacReferenceForm } from '@ifac/ui';
import LeftSide from '@/views/areas/awards/LeftSide.vue';

export default {
  components: {
 LeftSide, IfacReferenceForm,
},
  mixins: [ifacUiMixin, awardsMixin, referencesMixin],
  props: {
    reference: Object,
  },
  name: 'ReferencesEdit',
  async created() {
    this.formSchema = this.reference.form_schema;
    this.formValues = this.reference.form_values;
  },
  data() {
      return {
        formSchema: [],
        formValues: {},
        formErrors: {},
        scrollbarHeight: 0,
      };
  },
  methods: {
    saveForm() {
      this.formAction = 'save';
      this.$formulate.submit('formulateForm');
    },
    submitForm() {
      this.formAction = 'submit';
      this.$formulate.submit('formulateForm');
    },
    handleSubmitForm(data) {
      if (this.formAction === 'save') {
        this.mx_updateReference(data);
      }

      if (this.formAction === 'submit') {
        this.mx_submitReference(data);
      }
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/base/_variables.scss';
@import '@/assets/styles/base/_mixins.scss';
</style>
